import { ComponentChildren } from 'preact';
import { Children } from 'preact/compat';
import { wrapWithComponent } from 'utilities/components';

import { Item } from '../Item';

import styles from '../../FormLayout.module.scss';

interface RowProps {
  children: ComponentChildren;
}

export function Row({ children }: RowProps) {
  const itemsMarkup = Children.toArray(children).map((child, index) =>
    wrapWithComponent(child, Item, {
      key: index,
    }),
  );

  return (
    <div role="group" className={styles.Row}>
      <div className={styles.Items}>{itemsMarkup}</div>
    </div>
  );
}
